import { useRef } from 'react';

import clsx from 'clsx';

import Popup from '@popup/components/Popup';
import PopupWrapper from '@ui/components/PopupWrapper';
import useOnClickOutsideWithIgnore from '@ui/hooks/useOnClickOutsideWithIgnore';

import Selector from './Selector';

interface ListSelectorProps {
  handleClick: (title: string) => void;
  eventTitle: string;
  listData: string[];
  type?: 'inCard' | 'byButton';
  handleClose?: () => void;
}

const ListSelector = ({
  handleClick,
  listData,
  eventTitle,
  type = 'byButton',
  handleClose,
}: ListSelectorProps) => {
  const ref = useRef(null);

  useOnClickOutsideWithIgnore(
    ref,
    () => handleClick(eventTitle),
    'ignore-click-outside',
  );

  return (
    <div
      ref={ref}
      className={clsx(
        'fixed inset-x-2 bottom-2 flex items-center justify-center md:absolute md:inset-x-0 md:bottom-auto md:left-auto md:mx-2 md:w-auto md:min-w-min md:max-w-md',
        type === 'byButton' && 'md:top-[80px] lg:top-[70px]',
        type === 'inCard' && 'md:top-[100px] lg:top-[112px]',
      )}
    >
      <Popup>
        <PopupWrapper handleClick={handleClose}>
          {listData.map((listItem, index) => (
            <Selector
              key={index}
              isSelected={eventTitle === listItem}
              handleClick={handleClick}
              selectorTitle={listItem}
            >
              {listItem}
            </Selector>
          ))}
        </PopupWrapper>
      </Popup>
    </div>
  );
};

export default ListSelector;
